module.exports = __webpack_public_path__ + "static/media/profile_bio.d10f3e79.png";